import { Dropdown } from "components/ui";
import { ReactSVG } from "react-svg";
import asset from "assets/images";
import { AUTOMATION_ACTIONS } from "../enum";
import {
    AUTOMATION_DELETE_PERMISSION,
    AUTOMATION_UPDATE_PERMISSION,
} from "../permissions";

const AutomationsTableActions = ({ handleActionModal, automation }) => {
    return (
        <Dropdown
            size='sm'
            placeholder={
                <ReactSVG
                    src={asset?.icons?.horizontalEllipsis}
                    className='d-inline-flex'
                />
            }
            ddValueClass='borderless'
            className='table__dropdown'
            ddOptionsClass='table__dropdown'
            anchor={false}
            changeValue={false}
            onChange={({ value }) => handleActionModal?.(value, automation)}
            options={[
                {
                    value: AUTOMATION_ACTIONS.EDIT_AUTOMATION,
                    label: "Edit",
                    baseResources: AUTOMATION_UPDATE_PERMISSION,
                },
                {
                    value: AUTOMATION_ACTIONS.DELETE_AUTOMATION,
                    label: "Delete",
                    baseResources: AUTOMATION_DELETE_PERMISSION,
                },
            ]}
        />
    );
};

export default AutomationsTableActions;
